import { Box } from '@mui/material'

import { cellWrapperStyles } from './cellWrapperStyles'
import { ExpandableCellProps } from './types'

export const ExpandableCell = <T,>({
  children,
  columnMeta,
}: ExpandableCellProps<T>): JSX.Element => <Box sx={cellWrapperStyles(columnMeta)}>{children}</Box>
